module.exports = __webpack_public_path__ + "img/nolan-partly-cloudy-day.d9f02df1.svg";